<template>
  <div>
    <template v-if="!applicationNotFound">
      <router-view></router-view>
      <eds-wrapper ref="edsCreateWrapper" @mounted="onMountedEdsWrapper"/>
      <qr-code-modal ref="qrCodeCreateModal" @mounted="onMountedQrCodeModal" />
    </template>
    <template v-else>
      <error>
      </error>
      <application-not-found class="v-application mainClass"></application-not-found>
    </template>
    
  </div>
</template>

<script>
import {installEdsApi} from '../api/edsApi'
import { installQrCodeApi } from '../api/qrCodeApi'

export default {
  data: () => ({
    applicationNotFound: false
  }),
  components: { 
    'eds-wrapper': () => import('../components/EdsWrapper.vue'),
    'qr-code-modal': () => import('./QrCodeModal.vue'),
    'application-not-found': () => import('../views/ApplicationNotFound.vue'),
    'error': () => import('../layout/ErrorLayout.vue')
  },
  methods: {
    onMountedEdsWrapper() {
      installEdsApi(this.$refs.edsCreateWrapper)
    },

    onMountedQrCodeModal() {
      installQrCodeApi(this.$refs.qrCodeCreateModal)
    }
  },
  mounted() {
    this.applicationNotFound = this.$store.state.general.isApplicationNotFound
  }
}
</script>
<style lang="scss">
.mainClass {
  width: 100%;
  position: fixed !important;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
}
</style>